export class ConnectSourceAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "SourceAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectSourceAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
